import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import Classes from './Navbar.module.css';
import Logo from '../Logo/Logo';
import useScreenWidth from '../../../../../Hooks/useScreenWidth';
import { scrollToElement } from '../../../../../utils/scrollToElement';

export default function Navbar() {
    const navigateTo = useNavigate();
    const location = useLocation();
    const [activePage, setActivePage] = useState(location.pathname);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    const handleNavigate = (page) => {
        navigateTo(page);
    };

    const isMobile = useScreenWidth() < 480;

    return (
        <motion.div className={Classes.navbar} >
            <div style={{ display: 'flex' }} >
                <a href="/" style={{ textDecoration: 'none', marginLeft: '15px' }} >
                    <div style={{ height: '2.2rem' }}>
                        <Logo />
                    </div>
                </a>
            </div>
            <ul>
                <li
                    onClick={() => { scrollToElement('features', 70) }}
                    className={Classes.navActive}
                >
                    <h5>Features</h5>
                </li>
                <li
                    onClick={() => { scrollToElement('howItWorks', 20) }}
                    className={Classes.navActive}
                >
                    <h5>How it Works</h5>
                </li>
                <li
                    onClick={() => { scrollToElement('pricing', 70) }}
                    className={Classes.navActive}
                >
                    <h5> Pricing </h5>
                </li>
                <li
                    onClick={() => { scrollToElement('questions', 70) }}
                    className={Classes.navActive}
                >
                    <h5> FAQ </h5>
                </li>
            </ul>
            <div className={Classes.gridRight}>
                <button onClick={() => { navigateTo('/login') }} className={Classes.leftBtn}>
                    <h5> Sign in </h5>
                </button>
                <button type='button' onClick={() => { navigateTo('/signup') }} className={Classes.startBtn}>
                    <h5> Get started for free </h5>
                </button>
            </div>
        </motion.div>
    );
}
